
import React, { useRef } from 'react';
import { Space, Modal, Row, Col, Image } from "antd";
// import { MediumFont, NormalFont, NotoSansTamil } from "../../../../../Shared/components/font";
// import jsPDF from 'jspdf';
import CloseIcon from "../../../../../../assets/images/icon_menus/Close Button.svg";
// import Artboard from "../../../../../../assets/images/currency/Artboard.png";
import { Button } from "@mui/material";
import { ChallanFormat } from "./ChallanFormat";
import html2pdf from "html2pdf.js";

export const DeliveryChallan = React.forwardRef((props, ref) => {
    const { visible, handleClose, clsx, classes, form } = props;
    const printComponent = useRef(null);

    // const handleDownload = async (type = 'download') => {
    //     const content = printComponent.current;
    //     const doc = new jsPDF('pt', 'px', 'a4');
    //     doc.addFileToVFS('Roboto-Regular.ttf', NormalFont);
    //     doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
    //     doc.addFileToVFS('Roboto-Medium.ttf', MediumFont);
    //     doc.addFont('Roboto-Medium.ttf', 'RobotoMedium', 'normal');
    //     doc.addFileToVFS('NotoSansTamil-Regular.ttf', NotoSansTamil);
    //     doc.addFont('NotoSansTamil-Regular.ttf', 'NotoSansTamil', 'normal');
    //     doc.setFont("Roboto");
    //     doc.setFont("RobotoMedium");
    //     doc.setFont("NotoSansTamil");
    //     doc.html(content, {
    //         //fontFaces: fonts,
    //         callback: function (doc) {
    //             if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'development' || process.env.REACT_APP_PRODUCTION_MODE === 'qa') {
    //                 doc.addImage(Artboard, 'PNG', 100, doc.internal.pageSize.height - 275, 400, 54, '', '', 45);
    //             }
    //             if (type === 'print') {
    //                 doc.autoPrint();
    //                 window.open(doc.output('bloburl'));
    //             } else {
    //                 doc.save(`Delivery Challan-${form?.serialNo}`);
    //             }
    //         },
    //         autoPaging: 'text',
    //         margin: [10, 10, 10, 10],
    //         html2canvas: {
    //             scale: 0.433
    //         } // change the scale to whatever number you need
    //     });
    // };

    const handleDownload = async (type = 'download') => {
        const element = printComponent.current;
        // const content = printComponent.current;
        html2pdf()
            .from(element)
            .set({
                margin: [10, 5, 10, 5], // [top, left, bottom, right]
                filename: `Delivery Challan-${form?.serialNo}`,
                autoPaging: 'text',
                image: { type: "jpeg", quality: 1.0 },
                html2canvas: {
                    scale: 3, // Increase scale for high resolution
                    dpi: 300, // Ensure high DPI
                    useCORS: true,
                    letterRendering: true,
                }, // A4 width in pixels (≈ 210mm)
                pagebreak: { mode: ["css", "legacy"], before: '.page-break', avoid: '.no-break' },
                jsPDF: { unit: "mm", format: "a3", orientation: "portrait" },
            }).toPdf().get("pdf").then((pdf) => {
                if (type === 'print') {
                    pdf.autoPrint();
                    const blob = pdf.output("blob");
                    const formData = new FormData();
                    formData.append("mode", "file");        // tell server you're sending PDF
                    formData.append("file", blob, "file.pdf");
                    fetch(process.env.REACT_APP_EXE_CONNECT_URL, {
                        method: "POST",
                        body: formData
                    }).then(res => res.json()).then(data => { })
                        .catch(err => {
                            window.open(pdf.output('bloburl', "_blank"));
                            console.error(err);
                        });
                    // window.open(pdf.output('bloburl', "_blank"));
                } else {
                    pdf.save(`Delivery Challan-${form?.serialNo}`);
                }
            });
    }


    return (
        <Modal title="" open={visible} footer={null}
            onCancel={() => handleClose()}
            width={1030}
            closable={false}
            className={clsx(classes.invoiceDesign, classes.removeUnderline)}>
            <Row gutter={75} className={classes.invoiceHeader}>
                <Col span={24} className={clsx(classes.textAlignRight, classes.fontSize0)}>
                    <Space size={[20, 20]} direction="horizontal" align="center">
                        <Button
                            key="confirm"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownload('print')}
                            className={clsx(classes.AddMoreBtn)}
                        >Print</Button>
                        <Button
                            key="save"
                            color="primary"
                            variant="contained"
                            onClick={() => handleDownload()}
                            className={clsx(classes.modalBtn)}
                        >Download</Button>
                        <Image onClick={() => handleClose()} src={CloseIcon} preview={false} className={classes.cursor} />
                    </Space>
                </Col>
            </Row>
            <div ref={printComponent} className={clsx(classes.divToPrint)} style={{ position: "relative" }}>
                <ChallanFormat
                    details={form}
                    {...props}
                />
            </div>
        </Modal>
    )
});